<template>
  <v-row>
    <v-col
    cols="12"
    >
      <h1>About</h1>
    </v-col>
    <v-col
    cols="12"
    md="12"
    class="text-justify"
    >
      <v-card>
        <v-img 
        src="https://assets-us-01.kc-usercontent.com:443/95ac5f64-245d-00ad-3415-814fe52d35e6/73cf7d27-4914-4c52-8395-173ffb983f1c/Stephen02%20color%20(1).jpg?w=1024"
        lazy-src="https://assets-us-01.kc-usercontent.com:443/95ac5f64-245d-00ad-3415-814fe52d35e6/73cf7d27-4914-4c52-8395-173ffb983f1c/Stephen02%20color%20(1).jpg?w=128"
        class="headshot"
        ></v-img>
      </v-card>
      <p>
        I'm Stephen Beckett, a multi-skilled Reporter for 
        <a href="https://bbc.co.uk/bbcclick" target="blank">BBC Click</a>
         and award-winning Creative Technologist for the <a href="https://bbc.co.uk/vr" target="_blank">BBC VR Hub</a>.
      </p>
      <p>
        Over 7+ years at BBC News I have reported and produced technology stories around the world - 
        investigating the human impacts of new technology and exploring and 
        explaining the nuances of research and ideas. 
      </p>
      <p>
        I'm experienced in front and behind the camera, and specialise in finding creative 
        ways to tell complex stories.
      </p>
      <p>
        I use my background in Computer Science every day in my journalism, 
        but also in my role as a Creative Technologist at the BBC VR Hub and BBC more widely. 
      </p>
      <p>
        Virtual Reality content I have produced has <router-link to="/bbc-nothing-to-be-written-vr-oculus">won awards</router-link>, 
        and has been <router-link to="/bbc-click-360-vr-immersive-tv">shortlisted</router-link> 
        and shown at festivals around the world.
      </p>
      <p>
        I also design and develop interactive experiences - on 
        <router-link to="/big-screen-experiences-interactive-crowd">big screens for crowds and audiences</router-link>,
        and online using new techniques like <router-link to="/bbc-click-interactive-1000-branching-narrative">interactive narratives</router-link>,
        <router-link to="/webvr-virtual-reality-aframe-prototyping">WebVR</router-link> and 
        <router-link to="/bbc-click-360-vr-immersive-tv">360 video</router-link>.
        I've built software using a variety of <router-link to="/web-app-solutions-workflow-tools-js-vue">modern web technologies</router-link>,
        as well as tools like <router-link to="/big-screen-experiences-interactive-crowd">Unity and OpenFrameworks</router-link>.
      </p>
      <p>
        I also spent a year <router-link to="/levitation-haptics-ultrasound-installation">making things levitate</router-link>.
      </p>
      <p>
        I'm passionate about solving problems and finding the very best ways to communicate ideas, information and stories 
        - even if they don't exist yet.
      </p>
      <p class="pb-4">
        Take a look at my 
        <router-link to="/innovation-development">Innovation &amp; Development</router-link> projects, 
        my <router-link to="/tv-journalism">TV &amp; Journalism</router-link> work, 
        or get in touch directly.
      </p>

      <v-btn 
      rounded
      x-large
      depressed
      color="secondary"
      to="/contact"
      >
        Get in touch
      </v-btn>

      <v-btn 
      rounded
      large
      depressed
      class="ml-3"
      color="indigo lighten-3"
      to="/innovation-development"
      >
        Innovation &amp; Development
      </v-btn>

      <v-btn 
      rounded
      large
      depressed
      class="ml-3"
      color="indigo lighten-4"
      to="/tv-journalism"
      >
        TV &amp; Journalism
      </v-btn>
      
    </v-col>
    <v-col
      cols="12"
      class="pb-0 mb-0 mt-3"
    >
      <v-divider></v-divider>
    </v-col>
    <v-col
      cols="12"
    >
      <PortfolioList
          :num="4"
          :maxPerRow="4"
      >
      </PortfolioList>
    </v-col>
  </v-row>
</template>

<script>
import PortfolioList from '@/components/PortfolioList.vue'

export default {
    components: {
        PortfolioList
        // "https://assets-us-01.kc-usercontent.com:443/95ac5f64-245d-00ad-3415-814fe52d35e6/73cf7d27-4914-4c52-8395-173ffb983f1c/Stephen02%20color%20(1).jpg"
    }
}
</script>

<style lang="scss" scoped>
  .headshot {
    width: 30%;
    float: right;
    margin-bottom: 15px;
    margin-left: 25px;
  }

</style>